export class PinterestTracker {
    serviceName = 'pinterest';
    #eventData;

    constructor(eventData) {
        this.#eventData = eventData;
    }

    firePixelEvent(eventName) {
        const eventDataConfig = this.#eventDataConfig();

        if (!eventDataConfig.hasOwnProperty(eventName)) {
            return;
        }

        eventDataConfig[eventName]();
    }

    firePurchaseEvent(price, orderID, currency) {
        this.#triggerEvent('Checkout', {
            product_id: this.#eventData.name,
            product_name: this.#eventData.title,
            order_id: orderID,
            event_id: orderID,
            value: price,
            currency,
        });
    }

    fireCheckoutStartedEvent() {
        this.firePixelEvent('checkout_step_1_email_submitted');
    }

    fireAddPaymentInfoEvent(paymentType) {
        this.firePixelEvent('cc_number_entered');
    }

    #triggerEvent(eventName, eventData) {
        if (typeof pintrk !== 'function') {
            return;
        }

        pintrk('track', eventName, eventData);
    }

    #eventDataConfig() {
        const addPaymentInfoEvent = () => {
            this.#triggerEvent('AddPaymentInfo', {
                product_id: this.#eventData.name,
                product_name: this.#eventData.title,
                value: 0.0,
                currency: this.#eventData.currency,
                event_id: this.#eventData.session_id,
            });
        };

        return {
            first_buy_buttons_are_seen: () => {
                this.#triggerEvent('ViewCategory', {
                    property: 'First Buy Button',
                    product_id: this.#eventData.name,
                    product_name: this.#eventData.title,
                    value: 0.0,
                    currency: this.#eventData.currency,
                    event_id: this.#eventData.session_id,
                });
            },
            checkout_buy_button_is_clicked: () => {
                this.#triggerEvent('AddToCart', {
                    product_id: this.#eventData.name,
                    product_name: this.#eventData.title,
                    product_quantity: 1,
                    value: 0.0,
                    currency: this.#eventData.currency,
                    event_id: this.#eventData.session_id,
                });
            },
            checkout_step_1_email_submitted: () => {
                this.#triggerEvent('Lead', {
                    product_id: this.#eventData.name,
                    product_name: this.#eventData.title,
                    value: 0.0,
                    currency: this.#eventData.currency,
                    event_id: this.#eventData.session_id,
                });
            },
            cc_number_entered: addPaymentInfoEvent,
            paypal_button_click: addPaymentInfoEvent,
            apple_pay_button_click: addPaymentInfoEvent,
            apple_pay_available: () => {
                this.#triggerEvent('Custom', {
                    property: 'has_apple_pay_' + this.#eventData.name,
                    event_id: this.#eventData.session_id,
                });
            },
        };
    }
}
